<script>
export default {
  name: 'TaskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#368B57',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9994 19.2601H10.9294C10.4794 19.2601 10.1094 18.8901 10.1094 18.4401C10.1094 17.9901 10.4794 17.6201 10.9294 17.6201H19.9994C20.4494 17.6201 20.8194 17.9901 20.8194 18.4401C20.8194 18.9001 20.4494 19.2601 19.9994 19.2601Z"
      :fill="color"
    />
    <path
      d="M19.9994 12.9701H10.9294C10.4794 12.9701 10.1094 12.6001 10.1094 12.1501C10.1094 11.7001 10.4794 11.3301 10.9294 11.3301H19.9994C20.4494 11.3301 20.8194 11.7001 20.8194 12.1501C20.8194 12.6001 20.4494 12.9701 19.9994 12.9701Z"
      :fill="color"
    />
    <path
      d="M19.9994 6.67027H10.9294C10.4794 6.67027 10.1094 6.30027 10.1094 5.85027C10.1094 5.40027 10.4794 5.03027 10.9294 5.03027H19.9994C20.4494 5.03027 20.8194 5.40027 20.8194 5.85027C20.8194 6.30027 20.4494 6.67027 19.9994 6.67027Z"
      :fill="color"
    />
    <path
      d="M4.90969 8.02992C4.68969 8.02992 4.47969 7.93992 4.32969 7.78992L3.41969 6.87992C3.09969 6.55992 3.09969 6.03992 3.41969 5.71992C3.73969 5.39992 4.25969 5.39992 4.57969 5.71992L4.90969 6.04992L7.04969 3.90992C7.36969 3.58992 7.88969 3.58992 8.20969 3.90992C8.52969 4.22992 8.52969 4.74992 8.20969 5.06992L5.48969 7.78992C5.32969 7.93992 5.12969 8.02992 4.90969 8.02992Z"
      :fill="color"
    />
    <path
      d="M4.90969 14.3297C4.69969 14.3297 4.48969 14.2497 4.32969 14.0897L3.41969 13.1797C3.09969 12.8597 3.09969 12.3397 3.41969 12.0197C3.73969 11.6997 4.25969 11.6997 4.57969 12.0197L4.90969 12.3497L7.04969 10.2097C7.36969 9.88973 7.88969 9.88973 8.20969 10.2097C8.52969 10.5297 8.52969 11.0497 8.20969 11.3697L5.48969 14.0897C5.32969 14.2497 5.11969 14.3297 4.90969 14.3297Z"
      :fill="color"
    />
    <path
      d="M4.90969 20.3297C4.69969 20.3297 4.48969 20.2497 4.32969 20.0897L3.41969 19.1797C3.09969 18.8597 3.09969 18.3397 3.41969 18.0197C3.73969 17.6997 4.25969 17.6997 4.57969 18.0197L4.90969 18.3497L7.04969 16.2097C7.36969 15.8897 7.88969 15.8897 8.20969 16.2097C8.52969 16.5297 8.52969 17.0497 8.20969 17.3697L5.48969 20.0897C5.32969 20.2497 5.11969 20.3297 4.90969 20.3297Z"
      :fill="color"
    />
  </svg>
</template>
